export default {"src":"/_next/static/media/msr.6f754a48.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};